import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setPage = createAction(actionType.SET_PAGE);
const clearPage = createAction(actionType.CLEAR_PAGE);

export { setPage, clearPage };
